import { createGlobalStyle } from 'styled-components'

import { breakpoint } from 'styled-components-breakpoint';
import { normalize } from 'styled-normalize'

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  html {
    height: auto !important;
    width: auto !important;
  }

  *, :before, :after {
    box-sizing: border-box;
  }


  body {
    font-size: 16px;
    line-height: 1.3;
    font-family: 'Montserrat', sans-serif;
    padding-top: 170px;
    ${breakpoint('mobile')`
      font-size: 16px;
      line-height: 1.7;
      padding-top: 197px;
    `}
    font-style: normal;
    overflow: auto;
   
  }

  #root{
    position: relative;
  }

  h2{
    margin:0 0 10px;
  }
`


export const theme = {
    breakpoints: {
      sm: 0,
      mobile: 768,
      tabletPor: 1025,
      tablet: 1366
    },

    green1: "#96af91",
    brown1: "#8f5d2a",
    grey1: "#4e534f",
    black1: "#000000",
  
    font1: "arial",
    font2: "serif"

  };


